import { Routes, Route } from 'react-router-dom'

// Pages
import Home from '../pages/Home'
import CategoryProducts from '../pages/CategoryProducts'
import ProductDetail from '../pages/ProductDetail'
import Contact from '../pages/Contact'
import About from '../pages/About'
import FAQ from '../pages/FAQ'
import Terms from '../pages/Terms'
import NotFound from '../pages/NotFound'
import Privacy from '../pages/Privacy'
import DeleteUser from '../pages/DeleteUser'

const AppRoutes = () => {
  return (
    <Routes>
      {/* Home Route */}
      <Route path="/" element={<Home />} />
            
      {/* Product Routes */}
      <Route path="/categoria/:categoryName" element={<CategoryProducts />} />
      <Route path="/producto/:productId" element={<ProductDetail />} />
            
      {/* Static Pages */}
      <Route path="/contacto" element={<Contact />} />
      <Route path="/sobre-nosotros" element={<About />} />
      <Route path="/terminos-y-condiciones" element={<Terms />} />
      <Route path="/preguntas-frecuentes" element={<FAQ />} />
      <Route path="/aviso-de-privacidad" element={<Privacy />} />
      <Route path="/eliminar-cuenta" element={<DeleteUser />} />
            
      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes